import React from "react";
import "../styles/why-cloudare.css";
import { PhosphorIcon } from "./PhosphorIcon";

/**
 * HowWeHelp — replaces the old stock-photo "How can we help?" cards
 * (boardroom photo / "IMPLEMENTATION" stock image / "SUPPORT" wooden letters)
 * with clean, on-brand icon cards. Flow layout, tokens only.
 */
const STEPS = [
  {
    icon: "ClipboardText",
    title: "Project Scope (Gap Analysis)",
    body: "Every engagement starts with thorough discovery and clear scope definition, so delivery stays efficient and free of unwanted delays.",
  },
  {
    icon: "CodeBlock",
    title: "Implementation",
    body: "Our certified consultants deliver structured implementation with defined milestones, clean configuration and rigorous testing before go-live.",
  },
  {
    icon: "ShieldCheck",
    title: "Support",
    body: "Post go-live, our team provides ongoing AMS, enhancements and responsive support so your systems keep running smoothly.",
  },
];

export default function HowWeHelp() {
  return (
    <section className="why-cloudare" style={{ background: "var(--surface-elevated)" }}>
      <header className="why-cloudare__header">
        <p className="why-cloudare__eyebrow">How can we help</p>
        <h2 className="why-cloudare__title">From scope to support</h2>
        <p className="why-cloudare__lede">
          A structured delivery model — discovery, build and ongoing support —
          so your ERP and compliance programmes land on time and stay stable.
        </p>
      </header>
      <div className="why-cloudare__grid">
        {STEPS.map((s, i) => (
          <article className="wc-card" key={i}>
            <div className="wc-card__icon">
              <PhosphorIcon name={s.icon} size={24} />
            </div>
            <h3 className="wc-card__title">{s.title}</h3>
            <p className="wc-card__body">{s.body}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
